import React, { useState, useEffect } from 'react';
import Login from "./Login";
import AdminPanel from "./AdminPanel";
import BusinessTab from "./BusinessTab";
import DateFilter from "./DateFilter";
import CamerasBadge from "./CamerasBadge";
import './App.css';

/* Dashboard reduit a la seule vue Business : en-tete (comptes, periode,
   session) + la page Business. Les autres onglets ont ete retires. */

const pad = (n) => String(n).padStart(2, '0');
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

function fmtHeure(d) {
  if (!d) return '--';
  return d.toLocaleTimeString('fr-TN', { hour: '2-digit', minute: '2-digit' });
}

export default function App() {
  const todayStr = iso(new Date());

  const [from, setFrom] = useState(todayStr);
  const [to, setTo] = useState(todayStr);
  const [refresh, setRefresh] = useState(0);
  const [lastUpd, setLastUpd] = useState(null);
  const [showAdmin, setShowAdmin] = useState(false);
  const [currentUser, setCurrentUser] = useState(() => {
    try { const u = localStorage.getItem("peak_user"); return u ? JSON.parse(u) : null; } catch { return null; }
  });

  const changerPeriode = (f, t) => { setFrom(f); setTo(t); };

  // Actualisation auto uniquement quand la periode touche aujourd'hui :
  // sur une periode passee, les donnees ne bougent plus.
  useEffect(() => {
    if (to !== todayStr) return undefined;
    const id = setInterval(() => setRefresh((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, [to, todayStr]);

  if (!currentUser) return <Login onLogin={(u) => setCurrentUser(u)} />;

  return (
    <div className="app">
      {showAdmin && <AdminPanel user={currentUser} onClose={() => setShowAdmin(false)} />}

      <header className="hdr">
        <div className="hdr-brand">
          <div className="brand-mark">P</div>
          <div className="brand-text">
            <h1 className="brand-title">Luxolor Retail</h1>
            <p className="brand-sub">Intelligence</p>
          </div>
        </div>

        <div style={{ flex: 1 }} />

        <div className="hdr-right" style={{ flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          <CamerasBadge />
          <DateFilter from={from} to={to} onChange={changerPeriode} />
          <button className="hdr-btn" onClick={() => setRefresh((n) => n + 1)} title="Actualiser">↻</button>
          {lastUpd && <span className="hdr-time">{fmtHeure(lastUpd)}</span>}
          {currentUser?.role === "admin" && (
            <button onClick={() => setShowAdmin(true)} style={{ background: "rgba(37,99,235,.15)", border: "1px solid rgba(37,99,235,.3)", color: "#2563eb", borderRadius: 6, padding: "4px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>⚙️ Comptes</button>
          )}
          <span style={{ fontSize: 12, color: "var(--text3)" }}>👤 {currentUser?.nom}</span>
          <button onClick={() => { localStorage.removeItem("peak_token"); localStorage.removeItem("peak_user"); setCurrentUser(null); }}
            style={{ background: "rgba(239,68,68,.1)", border: "none", color: "#ef4444", borderRadius: 6, padding: "4px 10px", fontSize: 12, cursor: "pointer" }}>Déconnexion</button>
        </div>
      </header>

      <main className="main">
        <BusinessTab dateFrom={from} dateTo={to} days={14} refreshKey={refresh} onLoaded={setLastUpd} />
      </main>

      <footer className="footer">
        <span className="footer-brand">Luxolor Retail Intelligence</span>
        <span className="footer-sep">·</span>
        <span>Luxolor Tunisie</span>
        {to === todayStr && (
          <>
            <span className="footer-sep">·</span>
            <span>Actualisation auto 30s</span>
          </>
        )}
      </footer>
    </div>
  );
}
